/*
 * Free at-home try-on landing page (/pages/try-on).
 * Try-on orders: empty the cart, add the ring with line property purchase_type = pay_later (the same tag the
 * product page's "7-Day Risk-Free Try-On" button sets), set cart attribute landing_page = try-on, go to checkout.
 * The cart page and cart drawer are never shown.
 */
(function () {
  const dataEl = document.getElementById('tah-data');
  if (!dataEl) return;
  let data;
  try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const money = cents => `$${(cents / 100).toFixed(2)}`;
  const behavior = () => (window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
  const post = (url, body) => fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body || {})
  });

  const LANDING_PAGE = 'try-on';
  const TRY_ON = { purchase_type: 'pay_later' };
  const ATTRIBUTION_STORE = 'ir_meta_attr';
  const ATTRIBUTION_KEYS = ['fbclid', 'gclid', 'gbraid', 'wbraid', 'ttclid', 'msclkid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id'];

  const products = data.products || [];
  const byHandle = Object.fromEntries(products.map(p => [p.handle, p]));
  const state = {
    handle: byHandle[data.initial] ? data.initial : products[0]?.handle,
    size: null,
    busy: false
  };
  const current = () => byHandle[state.handle];
  const canBuy = (p, size) => !!(p && size && p.variants[size] && !p.soldOut.includes(size));
  if (!current()) return;

  /* ── product details ── */

  function renderDetails() {
    const p = current();
    $$('[data-tah="name"]').forEach(el => { el.textContent = p.name; });
    $$('[data-tah="price"]').forEach(el => { el.textContent = money(p.price); });
    $$('[data-tah="finish"]').forEach(el => { el.textContent = `${p.finish}, 7mm comfort-fit.`; });
    $$('[data-tah="rating"]').forEach(el => { el.textContent = Number(p.rating).toFixed(1); });
    $$('[data-tah="count"]').forEach(el => { el.textContent = String(p.count); });
    $$('[data-tah-ratingrow]').forEach(el => { el.hidden = !p.count; });
    $$('[data-tah="thumb"]').forEach(img => { img.src = p.thumb; });
    renderStickySize();
  }

  // Once a size is chosen, the sticky bar shows it (its button then starts the try-on straight away).
  function renderStickySize() {
    const p = current();
    const ready = canBuy(p, state.size);
    $$('[data-tah="size"]').forEach(el => { el.textContent = ready ? state.size : ''; });
    $$('[data-tah-sticky-size]').forEach(el => { el.hidden = !ready; });
    $$('[data-tah-sticky-rating]').forEach(el => { el.hidden = ready || !p.count; });
  }

  function renderStyles() {
    $$('#tah-styles [data-tah-style]').forEach(btn => {
      const on = btn.dataset.tahStyle === state.handle;
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', String(on));
    });
  }

  function renderSizes() {
    const p = current();
    const root = $('#tah-sizes');
    if (!root) return;
    root.innerHTML = p.sizes.map(size => {
      const id = `tah-size-${size.replace(/[^0-9a-z]+/gi, '-')}`;
      const out = !canBuy(p, size);
      return `<input id="${id}" type="radio" name="tah-size" value="${esc(size)}"${out ? ' disabled' : ''}${!out && state.size === size ? ' checked' : ''}>` +
        `<label for="${id}"${out ? ' title="Sold out"' : ''}>${esc(size)}${out ? '<span class="tah-visually-hidden"> (sold out)</span>' : ''}</label>`;
    }).join('');
  }

  function showError(msg) {
    const el = $('#tah-size-error');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-on');
  }

  function hideError() {
    const el = $('#tah-size-error');
    if (!el) return;
    el.textContent = '';
    el.classList.remove('is-on');
  }

  function selectStyle(handle) {
    if (!byHandle[handle] || handle === state.handle) return;
    state.handle = handle;
    const p = current();
    let note = '';
    if (state.size && !canBuy(p, state.size)) {
      note = `Size ${state.size} is sold out in ${p.name}. Please choose another size.`;
      state.size = null;
    }
    renderStyles();
    renderCarousel();
    renderSizes();
    renderDetails();
    if (note) showError(note); else hideError();
    trackViewContent();
  }

  /* ── carousel ── */

  const track = () => $('#tah-track');

  function renderCarousel() {
    const p = current();
    const t = track();
    if (!t) return;
    t.innerHTML = p.images.map((img, i) =>
      `<figure class="tah-slide${img.cutout ? ' tah-slide--cutout' : ''}"><img src="${esc(img.src)}" alt="${esc(img.alt)}" width="1000" height="1000" draggable="false"${i > 1 ? ' loading="lazy"' : ''}></figure>`
    ).join('');
    t.scrollLeft = 0;
    renderDots();
  }

  function slideCount() { return track()?.children.length || 0; }

  function slideIndex() {
    const t = track();
    return t ? Math.round(t.scrollLeft / Math.max(1, t.clientWidth)) : 0;
  }

  function renderDots() {
    const n = slideCount();
    const dots = $('#tah-dots');
    if (dots) {
      dots.innerHTML = n > 1
        ? Array.from({ length: n }, (_, i) => `<button type="button" data-tah-dot="${i}" aria-label="Show photo ${i + 1} of ${n}"${i === 0 ? ' aria-current="true"' : ''}></button>`).join('')
        : '';
    }
    $$('.tah-carousel__nav').forEach(btn => { btn.hidden = n < 2; });
  }

  function syncDots() {
    const i = slideIndex();
    $$('#tah-dots [data-tah-dot]').forEach((btn, k) => btn.setAttribute('aria-current', String(k === i)));
  }

  function goToSlide(i) {
    const t = track();
    const n = slideCount();
    if (!t || !n) return;
    const k = Math.max(0, Math.min(n - 1, i));
    t.scrollTo({ left: k * t.clientWidth, behavior: behavior() });
  }

  function initCarousel() {
    const t = track();
    if (!t) return;
    renderDots();
    let ticking = false;
    t.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; syncDots(); });
    }, { passive: true });
    t.addEventListener('keydown', e => {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      goToSlide(slideIndex() + (e.key === 'ArrowRight' ? 1 : -1));
    });
  }

  /* ── scrolling ── */

  function focusSizes() {
    const target = $('#tah-sizes input:checked') || $('#tah-sizes input:not(:disabled)');
    target?.focus({ preventScroll: true });
  }

  function scrollToBuyBox() {
    $('#tah-buybox')?.scrollIntoView({ behavior: behavior(), block: 'start' });
    focusSizes();
  }

  function scrollToReviews() {
    $('#tah-reviews')?.scrollIntoView({ behavior: behavior(), block: 'start' });
  }

  /* ── try-on checkout ── */

  async function refreshStock(p) {
    try {
      const res = await fetch(`/products/${encodeURIComponent(p.handle)}.js`);
      const json = await res.json();
      p.soldOut = (json.variants || []).filter(v => !v.available).map(v => String(v.option1));
    } catch (e) {}
  }

  function setBusy(busy) {
    state.busy = busy;
    $$('[data-tah-checkout], [data-tah-sticky]').forEach(btn => {
      if (!btn.dataset.label) btn.dataset.label = btn.textContent.trim();
      btn.disabled = busy;
      btn.textContent = busy ? 'Starting your try-on…' : btn.dataset.label;
    });
  }

  async function startTryOn() {
    if (state.busy) return;
    const p = current();
    if (!state.size) {
      showError('Choose a size to try it at home.');
      const sizes = $('#tah-sizes');
      const r = sizes?.getBoundingClientRect();
      if (r && (r.top < 0 || r.bottom > window.innerHeight)) sizes.scrollIntoView({ behavior: behavior(), block: 'center' });
      focusSizes();
      return;
    }
    if (!canBuy(p, state.size)) {
      showError(`Size ${state.size} is sold out in ${p.name}. Please choose another size.`);
      return;
    }
    const size = state.size;
    setBusy(true);
    try {
      await post('/cart/clear.js');
      const res = await post('/cart/add.js', { items: [{ id: p.variants[size], quantity: 1, properties: TRY_ON }] });
      if (!res.ok) {
        const err = new Error('Add to cart failed');
        err.status = res.status;
        throw err;
      }
      trackTripleAdd(p, size);
      await post('/cart/update.js', { attributes: { landing_page: LANDING_PAGE } });
      shareMetaCookies();
      window.location.href = '/checkout';
    } catch (e) {
      setBusy(false);
      if (e.status === 422) {
        await refreshStock(p);
        if (!canBuy(p, size)) {
          state.size = null;
          renderSizes();
          renderStickySize();
          showError(`Sorry, size ${size} in ${p.name} just sold out. Please choose another size.`);
          return;
        }
        showError('Sorry, we couldn’t start your try-on. Please try again.');
        return;
      }
      showError('Something went wrong starting your try-on. Please try again.');
    }
  }

  // Sticky bar: with a size chosen, start the try-on right here; otherwise take the visitor to the size picker.
  function stickyTryOn() {
    if (canBuy(current(), state.size)) { startTryOn(); return; }
    scrollToBuyBox();
    showError('Choose a size to try it at home.');
  }

  // Coming back from checkout with the browser's back button restores this page as it was left.
  window.addEventListener('pageshow', e => { if (e.persisted && state.busy) setBusy(false); });

  /* ── size guide ── */

  let lastFocus = null;

  function openSizeGuide() {
    const modal = $('#tah-size-modal');
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('tah-modal-open');
    document.body.style.overflow = 'hidden';
    $('[data-tah-close]', modal)?.focus();
  }

  function closeSizeGuide() {
    const modal = $('#tah-size-modal');
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('tah-modal-open');
    document.body.style.overflow = '';
    lastFocus?.focus({ preventScroll: true });
  }

  /* ── sticky bar ── */

  function initSticky() {
    const bar = $('#tah-sticky');
    const watch = [$('.tah-hero'), $('#tah-buybox')].filter(Boolean);
    if (!bar || !watch.length || !('IntersectionObserver' in window)) return;
    const seen = new Map(watch.map(el => [el, true]));
    const update = () => {
      const show = ![...seen.values()].some(Boolean);
      bar.classList.toggle('is-visible', show);
      bar.inert = !show;
      bar.setAttribute('aria-hidden', String(!show));
    };
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => seen.set(entry.target, entry.isIntersecting));
      update();
    });
    watch.forEach(el => io.observe(el));
  }

  /* ── accordions, videos, reviews ── */

  function initQualityAccordion() {
    const root = $('#tah-quality-acc');
    if (!root) return;
    root.addEventListener('toggle', e => {
      if (!e.target.open) return;
      $$('details', root).forEach(item => { if (item !== e.target) item.open = false; });
    }, true);
  }

  // Customer videos play muted while they're on screen and pause when scrolled away. Tapping one turns its
  // sound on (and mutes the others); tapping again turns it off.
  function setSound(card, on) {
    const video = $('video', card);
    if (!video) return;
    video.muted = !on;
    card.classList.toggle('has-sound', on);
    card.setAttribute('aria-label', card.getAttribute('aria-label').replace(/^Turn sound (on|off)/, on ? 'Turn sound off' : 'Turn sound on'));
  }

  function toggleSound(card) {
    const video = $('video', card);
    if (!video) return;
    const on = video.muted;
    $$('[data-tah-video]').forEach(other => { if (other !== card) setSound(other, false); });
    setSound(card, on);
    if (on) video.play().catch(() => {});
  }

  function initVideos() {
    const cards = $$('[data-tah-video]');
    if (!cards.length) return;
    cards.forEach(card => { const v = $('video', card); if (v) { v.muted = true; v.playsInline = true; } });
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Watch the cards, not the videos: a zoomed-in video is larger than its card, so it never looks half visible.
    const io = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const v = $('video', entry.target);
        if (!v) return;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.5) v.play().catch(() => {});
        else if (!v.paused) v.pause();
      });
    }, { threshold: [0, 0.5, 1] });
    cards.forEach(card => io.observe(card));
  }

  // This page has no links that leave it. The Judge.me widget adds a few: hidden "Write a review" and "Judge.me"
  // links (the latter outside the reviews section), which are removed, and review-photo links, which open
  // Judge.me's photo viewer on the page (as on the other landing pages) and are kept from opening a new tab.
  const isPhotoViewer = a => a.matches('.jdgm-rev__pic-link, [data-mfp-src]');

  function tidyReviews() {
    const root = $('#tah-reviews');
    if (!root) return;
    const clean = () => {
      $$('a.jdgm-write-rev-link, a.jdgm-random-link').forEach(a => a.remove());
      $$('a[href]', root).forEach(a => {
        if (isPhotoViewer(a)) { a.removeAttribute('target'); return; }
        let url;
        try { url = new URL(a.getAttribute('href'), location.href); } catch (e) { return; }
        const samePage = url.origin === location.origin && url.pathname === location.pathname;
        if (samePage) return;
        a.dataset.tahHref = a.getAttribute('href');
        a.removeAttribute('href');
        a.removeAttribute('target');
      });
    };
    clean();
    const observer = new MutationObserver(clean);
    observer.observe(root, { childList: true, subtree: true });
    observer.observe(document.body, { childList: true });
    // A plain click opens the photo viewer (Judge.me handles it); a ctrl/middle click would open the image instead.
    const stayOnPage = e => {
      const a = e.target.closest('a[href]');
      if (a && isPhotoViewer(a) && (e.button !== 0 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey)) e.preventDefault();
    };
    root.addEventListener('click', stayOnPage, true);
    root.addEventListener('auxclick', stayOnPage, true);
  }

  /* ── tracking and attribution ── */

  function readCookie(name) {
    const row = document.cookie.split('; ').find(part => part.startsWith(`${name}=`));
    return row ? decodeURIComponent(row.slice(name.length + 1)) : '';
  }

  function writeRootCookie(name, value) {
    if (!value) return;
    const root = /(?:^|\.)iconic-rings\.com$/i.test(location.hostname) ? '; domain=.iconic-rings.com' : '';
    document.cookie = `${name}=${value}; path=/; max-age=7776000; SameSite=Lax${root}`;
  }

  function storedAttribution() {
    let stored = {};
    try { stored = JSON.parse(sessionStorage.getItem(ATTRIBUTION_STORE) || '{}'); } catch (e) { stored = {}; }
    const params = new URLSearchParams(location.search);
    ATTRIBUTION_KEYS.forEach(key => { const value = params.get(key); if (value) stored[key] = value; });
    try { sessionStorage.setItem(ATTRIBUTION_STORE, JSON.stringify(stored)); } catch (e) {}
    return stored;
  }

  function shareMetaCookies() {
    const stored = storedAttribution();
    if (stored.fbclid && !readCookie('_fbc')) writeRootCookie('_fbc', `fb.1.${Date.now()}.${stored.fbclid}`);
    const fbp = readCookie('_fbp');
    const fbc = readCookie('_fbc');
    if (fbp) writeRootCookie('_fbp', fbp);
    if (fbc) writeRootCookie('_fbc', fbc);
  }

  // Product views come only from this page; add-to-cart and checkout events come from Shopify's apps.
  function trackViewContent() {
    const p = current();
    const value = p.price / 100;
    const id = String(p.id);
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'ViewContent', {
        content_ids: [id], content_type: 'product_group', content_name: p.name, content_category: 'Rings',
        value, currency: 'USD', contents: [{ id, quantity: 1, item_price: value }]
      });
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'view_item', {
        currency: 'USD', value, items: [{ item_id: id, item_name: p.name, item_category: 'Rings', price: value, quantity: 1 }]
      });
    }
  }

  function trackTripleAdd(p, size) {
    if (typeof window.TriplePixel !== 'function') return;
    window.TriplePixel('AddToCart', { item: String(p.id), q: 1, v: String(p.variants[size]) });
  }

  /* ── events ── */

  document.addEventListener('click', e => {
    const t = e.target;
    if (t.closest('[data-tah-checkout]')) { startTryOn(); return; }
    if (t.closest('[data-tah-sticky]')) { stickyTryOn(); return; }
    if (t.closest('[data-tah-scroll]')) { scrollToBuyBox(); return; }
    if (t.closest('[data-tah-reviews]')) { scrollToReviews(); return; }
    if (t.closest('[data-tah-size-guide]')) { openSizeGuide(); return; }
    if (t.closest('[data-tah-close]')) { closeSizeGuide(); return; }
    if (t.id === 'tah-size-modal') { closeSizeGuide(); return; }
    const style = t.closest('[data-tah-style]');
    if (style) { selectStyle(style.dataset.tahStyle); return; }
    const dot = t.closest('[data-tah-dot]');
    if (dot) { goToSlide(Number(dot.dataset.tahDot)); return; }
    const nav = t.closest('[data-tah-slide]');
    if (nav) { goToSlide(slideIndex() + Number(nav.dataset.tahSlide)); return; }
    const card = t.closest('[data-tah-video]');
    if (card) toggleSound(card);
  });

  $('#tah-sizes')?.addEventListener('change', e => {
    if (e.target.name !== 'tah-size') return;
    state.size = e.target.value;
    hideError();
    renderStickySize();
  });

  document.addEventListener('keydown', e => {
    const modal = $('#tah-size-modal');
    if (!modal || modal.hidden) return;
    if (e.key === 'Escape') { closeSizeGuide(); return; }
    if (e.key === 'Tab') { e.preventDefault(); $('[data-tah-close]', modal)?.focus(); }
  });

  /* ── start ── */

  $$('#tah-sizes input').forEach(input => { input.checked = false; });
  initCarousel();
  initSticky();
  initQualityAccordion();
  initVideos();
  tidyReviews();
  trackViewContent();
  shareMetaCookies();
  window.setTimeout(shareMetaCookies, 800);
})();
